import { format, getQuarter } from 'date-fns';
import * as moment from 'moment';
// import 'moment-timezone';
// import * as from "moment-timezone";
import queryString from 'query-string';
import * as React from 'react';
import { DropdownButton, MenuItem, OverlayTrigger, Popover, Tooltip } from 'react-bootstrap';
import { withRouter } from 'react-router';
import { RouteComponentProps} from 'react-router-dom';
import { toast } from 'react-toastify';
import { setLoading, setSuccess } from '../../actions/loadingActions';
import { quarterMonths, years, INSPECTIONADDCUTOFF, INSPECTIONNONOPCUTOFF} from '../../constants/generals';
import { IHistory } from '../../interfaces';
import { PlantModel } from '../../model/PlantModel';
import { SettledFormModel } from '../../model/SettledFormModel';
import { deleteForm, getSettledForms } from '../../services/plantService';
import '../Reports/reports.scss';
import { RDatePicker } from '../reusableComponents/DatePicker';
import { MonthPicker } from '../reusableComponents/MonthPicker';
import { connect } from 'react-redux';
import { getCurentDate } from 'src/utils/generalUtils';

export interface IFooterCardProps {
    id: string;
    onClick?: Function;
    isClickable: boolean;
    plantUID: string;
    label: string | JSX.Element;
    date: Date;
    redirectTo: string;
    popOverMessage?: string;
    outfall?: string;
    popOverContent?: JSX.Element;
    customPopover?: JSX.Element;
    InCompleteOutfalls?: string[];
    // history: any;
    history?: IHistory;
    location?: {
        search: string;
    };
}

export interface IFooterCardState {
    isLoading: boolean;
    date: Date;
    month: string;
    year: string;
    quarter: string;
    outfall: string;
    selectedOutfall: string;
    isClickable: boolean;
    popoverMonth: Date;
    monthSelect: string;
    quarterString: string;
}
// type IFooterCardProps = CustomFooterCardProps & RouteComponentProps<any>;

export class FooterCardImpl extends React.PureComponent<IFooterCardProps, IFooterCardState> {
    constructor(props: IFooterCardProps) {
        super(props);
        let date = new Date();
        let quarter = getQuarter(date).toString().length > 1 ?
            getQuarter(date).toString() : `0${getQuarter(date).toString()}`;
        let monthSelect = ((Number(quarter) - 1) * 3 + 1).toString();
        let quarterString;
        quarterMonths().map((year, index) => {
            if (year.value === quarter) {
                quarterString = year.label;
            }
        });
        monthSelect = monthSelect.length > 1 ? monthSelect : '0' + monthSelect;
        if (this.props.location.search) {
            const { search } = this.props.location;
            const dateSelected = (queryString.parse(search).date);
            // date = moment(dateSelected).tz('America/Chicago').toDate();
            date = moment(dateSelected).toDate();
            quarter = queryString.parse(search).quarter ? queryString.parse(search).quarter : quarter;
            monthSelect = ((Number(quarter) - 1) * 3 + 1).toString();
            monthSelect = monthSelect.length > 1 ? monthSelect : '0' + monthSelect;
            quarterMonths().map((year, index) => {
                if (year.value === quarter) {
                    quarterString = year.label;
                }
            });
        }
        this.state = {
            isClickable: props.isClickable,
            date: date, isLoading: false, month: format(date, 'MM-DD-YYYY'),
            year: date.getFullYear().toString(), quarter,
            outfall: '', selectedOutfall: '', popoverMonth: new Date(),
            monthSelect, quarterString
        };
    }

    handleDateChange = async (date) => {
        const { plantUID: id } = this.props;
        this.setState({
            date
        });
        const dateFormatted = date.split('-');
        this.props.history.push(`?date=${date}`);
        const selected = `${dateFormatted[1]}${dateFormatted[2]}${dateFormatted[0]}`;
        setLoading('InspectionFooter');
        await getSettledForms(selected, this.props.plantUID);
        setSuccess('InspectionFooter');
    }

    handleMonthChange = async (month, selectedMonth, selectedMonthForAPI) => {
        const { plantUID: id } = this.props;
        this.setState({
            month,
            popoverMonth: month
        });
        this.props.history.push(`?date=${selectedMonth}`);
        setLoading('InspectionFooter');
        await getSettledForms(selectedMonthForAPI, this.props.plantUID);
        setSuccess('InspectionFooter');
    }

    handleOutfallSelect = (value) => {
        const { props: { InCompleteOutfalls } } = SettledFormModel.get(this.props.plantUID);
        if (InCompleteOutfalls.indexOf(`${value}`) <= -1) {
            toast.success(`${value} is already completed.`, {
                position: toast.POSITION.TOP_RIGHT,
                className: 'success-toast'
            });
            this.setState({
                isClickable: true
            });
        } else {
            this.setState({
                isClickable: false
            });
        }
        this.setState({
            selectedOutfall: value
        });
    }

    handleQuarterChange = async (year, quarter) => {
        let quarterString;
        quarterMonths().map((year, index) => {
            if (year.value === quarter) {
                quarterString = year.label;
            }
        });
        let monthSelect = ((Number(quarter) - 1) * 3 + 1).toString();
        monthSelect = monthSelect.length > 1 ? monthSelect : '0' + monthSelect;
        const { plantUID: id } = this.props;
        const { selectedOutfall } = this.state;
        this.setState({
            year, quarter, monthSelect, quarterString
        });
        const date = `${monthSelect}01${year}`;
        const dateSelected = `${monthSelect}-01-${year}`;
        this.props.history.push(`?date=${dateSelected}&&quarter=${quarter}&&outfall=${selectedOutfall}`);
        setLoading('InspectionFooter');
        await getSettledForms(date, this.props.plantUID);
        setSuccess('InspectionFooter');
    }

    getButtonProps = (url: string) => {
        let props = {};
        if (this.props.isClickable) {
            return {
                ...props, isClickable: true, onClick: this.props.history.push(url)
            };
        }
        return props;
    }

    formName = this.props.redirectTo.split('/')[2];

    getURLOfDailyForm = (redirectTo: string) => {
        const dailyFormName = this.props.redirectTo.split('/')[1];
        const plantInstance = PlantModel.get(this.props.plantUID);
        // const { history: { push }, id } = this?.props;
        const { history, id } = this.props;

        const settledFormInstance = SettledFormModel.get(this.props.plantUID);
        if (this.props.isClickable && dailyFormName === 'DailyForm') {
            /*tslint:disable-next-line*/
            return history.push(`${redirectTo}/${format(this.state.date, 'MM-DD-YYYY')}/${plantInstance.props.id}/${settledFormInstance.props[dailyFormName]}`)
        } else if (this.props.isClickable && dailyFormName === 'PlantPreventive') {
            /*tslint:disable-next-line*/
            return history.push(`${redirectTo}/${format(this.state.date, 'MM-DD-YYYY')}/${plantInstance.props.id}/${settledFormInstance.props[dailyFormName]}`)
        }

        return history.push(`${redirectTo}/${format(this.state.date, 'MM-DD-YYYY')}/${plantInstance.props.id}`);
    }

    getURLOfMonthlyForm = (redirectTo: string) => {
        const plantInstance = PlantModel.get(this.props.plantUID);
        const { history} = this.props;
        const settledFormInstance = SettledFormModel.get(this.props.plantUID);
        if (this.props.isClickable && this.formName !== 'MonthlyUSTSpill') {
            /*tslint:disable-next-line*/
            return history.push(`${redirectTo}/${format(this.state.date, 'MM-DD-YYYY')}/${plantInstance.props.id}/${plantInstance.props.Plant_Region}/${settledFormInstance.props[this.formName]}`)
        } else if (this.props.isClickable && this.formName === 'MonthlyUSTSpill') {
            /*tslint:disable-next-line*/
            return history.push(`${redirectTo}/${format(this.state.date, 'MM-DD-YYYY')}/${plantInstance.props.id}/${plantInstance.props.Plant_Region}/1/${settledFormInstance.props[this.formName]}`)
        } else if (!this.props.isClickable && this.formName === 'MonthlyUSTSpill') {
            /*tslint:disable-next-line*/
            return history.push(`${redirectTo}/${format(this.state.date, 'MM-DD-YYYY')}/${plantInstance.props.id}/${plantInstance.props.Plant_Region}/0/${settledFormInstance.props[this.formName]}`)
        }
        /*tslint:disable-next-line*/
        return history.push(`${redirectTo}/${format(this.state.date, 'MM-DD-YYYY')}/${plantInstance.props.id}/${plantInstance.props.Plant_Region}`)
    }

    getURLOfQTRVisualForm = (redirectTo: string) => {
        const plantInstance = PlantModel.get(this.props.plantUID);
        const { history} = this.props;
        const { quarter, year, monthSelect } = this.state;
        const dateSelected = `${monthSelect}-01-${year}`;
        const settledFormInstance = SettledFormModel.get(this.props.plantUID);
        if (this.getOutFalls().length <= 0) {
            toast.error('This plant is not allowed to fill QTR Visual form.', {
                position: toast.POSITION.TOP_CENTER,
                className: 'failed-toast'
            });
            return;
        }
        if (!this.state.selectedOutfall) {
            toast.error('Please Select an Outfall first.', {
                position: toast.POSITION.TOP_CENTER,
                className: 'failed-toast'
            });
            return;
        }
        if (this.state.isClickable) {
            /*tslint:disable-next-line*/
            return history.push(`${redirectTo}/${dateSelected}/${this.state.selectedOutfall}/${plantInstance.props.id}/${plantInstance.props.Plant_Region}/${settledFormInstance.props.Outfalls[this.state.selectedOutfall]}`)
        }
        /*tslint:disable-next-line*/
        return history.push(`${redirectTo}/${dateSelected}/${this.state.selectedOutfall}/${plantInstance.props.id}/${plantInstance.props.Plant_Region}`)
    }

    getURLOfShopInspectionForm = (redirectTo: string) => {
        const plantInstance = PlantModel.get(this.props.plantUID);
        const { history} = this.props;
        const { quarter, year, monthSelect } = this.state;
        const dateSelected = `${monthSelect}-01-${year}`;
        const settledFormInstance = SettledFormModel.get(this.props.plantUID);
        if (this.props.isClickable) {
            /*tslint:disable-next-line*/
            return history.push(`${redirectTo}/${dateSelected}/${plantInstance.props.id}/${plantInstance.props.Plant_Region}/${settledFormInstance.props[this.formName]}`)
        }
        /*tslint:disable-next-line*/
        return history.push(`${redirectTo}/${dateSelected}/${plantInstance.props.id}/${plantInstance.props.Plant_Region}`)
    }

    renderPopOverTop = (plantUID: string, formType: string, outFall: string) => {
        const { history, redirectTo, isClickable } = this.props;
        const selectedDate = getCurentDate(this.state.date,'yyyy-MM-DD');
        const insAddCutoff = getCurentDate('07-01-2024','yyyy-MM-DD');
        const insNONOPCutoff = getCurentDate(INSPECTIONNONOPCUTOFF,'yyyy-MM-DD');  
        const isAddable = moment(insAddCutoff).isAfter(selectedDate, 'day');
        const isEditable = moment(insNONOPCutoff).isAfter(moment(), 'day');
        const title = !isClickable ? 'Begin Form?' : 'Edit Form?';
        /* const popOverTop = <Popover
            id="popover-positioned-top"
            className="footer-popover"
            title={!isClickable ? 'Begin Form?' : 'Edit Form?'}>
            <RDatePicker
                format="YYYY-MM-DD"
                value={this.state.date}
                onChange={this.handleDateChange}
            />
            <div className="popover-footer-button" >
                <button
                    onClick={() => this.getURLOfDailyForm(redirectTo)}
                >{!isClickable ? 'Begin Form' : 'Edit Form'}</button>
            </div>
        </Popover>; */
        const popOverTop = <Popover
            id="popover-positioned-top"
            className="footer-popover">
            {/* <Popover.Title as='h2' className="popover-title">{title}</Popover.Title> */}
            <div className="popover-content">
                <div className="list-footer-daily">
                    <RDatePicker
                        format="YYYY-MM-DD"
                        value={this.state.date}
                        onChange={this.handleDateChange}
                    />
                   
                </div>
                <div className="popover-footer-button">
                    { (!isClickable && isAddable?<button onClick={() => this.getURLOfDailyForm(redirectTo)} > Begin Form </button>: (isClickable ? <button onClick={() => this.getURLOfDailyForm(redirectTo)} > Edit Form </button> : <p>You can Add/Update inspections upto June 30. Please <a target="_blank" href='https://www.enviroconnect.net/'>click here</a> for new EnviroConnect portal.</p> ) )
                    }
   
                </div>
            </div>
        </Popover>;
 
        return popOverTop;
    }

    renderMonthlyPopOver = (plantUID: string, formType: string, outFall: string) => {
        const { redirectTo, isClickable } = this.props;  
        const title = !isClickable ? 'Begin Form?' : 'Edit Form?';
        const selectedDate = getCurentDate(this.state.date,'yyyy-MM-DD');
        const insAddCutoff = getCurentDate(INSPECTIONADDCUTOFF,'yyyy-MM-DD');
        const insNONOPCutoff = getCurentDate(INSPECTIONNONOPCUTOFF,'yyyy-MM-DD');
        const isAddable = moment(insAddCutoff).isAfter(selectedDate, 'month');
        const isEditable = moment(insNONOPCutoff).isAfter(moment(), 'month');
 
        return <Popover
            id="popover-positioned-top"
            className="footer-popover inspection-popover"
            title={<span>{!this.props.isClickable ? 'Begin Form?' : 'Edit Form?'} {this.formName=='MonthlySPCC'? <OverlayTrigger placement="top" overlay={  <Tooltip id={`Tooltip - ${1} `}> <span>{ 'You can only begin/update Monthly SPCC inspection for and after Aug 2020.' }</span> </Tooltip>}>
            <span style={{ opacity: 1, cursor:'default', marginLeft: '15px', }} >{<i className="fa fa-question-circle" style={{float: 'right', fontSize:'15px', color: 'red'}}  ></i>} </span>
        </OverlayTrigger> : '' }</span> }>  
            <div className="popover-content">
                <div className="popover-footer-button">
                    <div className="list-footers-monthly">
                    <MonthPicker
                        defaultValue={ this.state.month }
                        years={[2013, 2015, 2016]}
                        onClick={this.handleMonthChange}
                        popover={true}
                        min={this.formName=='MonthlySPCC' && "8/2020"}
                    />
                    </div>
                    {
                        <div className="popover-footer-button">  
                            { 
                            // (!isClickable && isAddable?<button onClick={() => this.processMonthlyClick()} > Begin Form </button>: (isClickable ? <button onClick={() => this.processMonthlyClick()} > Edit Form </button> : <p>You can Add/Update inspections upto June, 2024. Please <a target="_blank" href='https://www.enviroconnect.net/'>click here</a> for new EnviroConnect portal.</p> ) )
                            <p>You can see the inspections before July 2024 in Reports. Please <a target="_blank" href='https://www.enviroconnect.net/'>click here</a> for new EnviroConnect portal.</p>
                            }
                        </div>
                     
                    }
                </div>
            </div>
        </Popover>;
    }

    renderMonthlyPopOverOld = (plantUID: string, formType: string, outFall: string) => { 
        const { redirectTo, isClickable } = this.props; 
        const popOverTop = <Popover
            id="popover-positioned-top"
            className="footer-popover inspection-popover"
            //title={<span>{!this.props.isClickable ? 'Begin Form?' : 'Edit Form?'}{this.formName=='MonthlySPCC'? <i className="fa fa-question-circle" style={{float: 'right', fontSize:'15px', color: 'red'}} title="You can only begin/update Monthly SPCC inspection for and after Aug 2020."></i> : ''}</span>}>
            title={<span>{!this.props.isClickable ? 'Begin Form?' : 'Edit Form?'} {this.formName=='MonthlySPCC'? <OverlayTrigger placement="top" overlay={  <Tooltip id={`Tooltip - ${1} `}> <span>{ 'You can only begin/update Monthly SPCC inspection for and after Aug 2020.' }</span> </Tooltip>}>
            <span style={{ opacity: 1, cursor:'default', marginLeft: '15px', }} >{<i className="fa fa-question-circle" style={{float: 'right', fontSize:'15px', color: 'red'}}  ></i>} </span>
        </OverlayTrigger> : '' }</span> }>
                
            <MonthPicker
                //defaultValue={ this.formName=='MonthlySPCC' &&  format(this.state.month, 'YYYY-MM-DD')< format('2020-08-02', 'YYYY-MM-DD')? null : this.state.month }
                defaultValue={ this.state.month }
                years={[2013, 2015, 2016]}
                onClick={this.handleMonthChange}
                popover={true}
                // min={this.formName=='MonthlySPCC' && "8/2020"}
                min={this.formName === 'MonthlySPCC' ? "8/2020" : undefined}

            />
            <div className="popover-footer-button" >
                {/* <button
                    onClick={() => this.getURLOfMonthlyForm(redirectTo)}
                >{!this.props.isClickable ? 'Begin Form' : this.props.popOverMessage || 'Edit Form'}</button> */}
                <button
                    onClick={() => this.processMonthlyClick() }
                >{!this.props.isClickable ? 'Begin Form' : this.props.popOverMessage || 'Edit Form'}</button>
                
            </div>
        </Popover>;
        return popOverTop;
    }
    processMonthlyClick() {
        const { redirectTo, isClickable } = this.props;
        let date = this.state.month || format(new Date(), 'MMM YYYY');  
        let dateDet = date.split('-');
        let month = Number(dateDet[0]);
        let year = Number(dateDet[2]);  
        if(this.formName=='MonthlySPCC' && ( year<2020 || ( year==2020 && month<8) ) ) {  
            this.showErrorMessage('You cannot begin/update Monthly SPCC inspection before Aug 2020.');
            return;
        }
        this.getURLOfMonthlyForm(redirectTo);
    }
    showErrorMessage(message) {
        toast.error(`${message}`, {
            position: toast.POSITION.TOP_RIGHT,
            className: 'failed-toast'
        });
    }

    renderShopInspectionPopOver = (plantUID: string, formType: string, outFall: string) => {
        const { redirectTo, isClickable } = this.props;
        let quarter;
        const popOverTop = <Popover
            id="popover-positioned-top"
            className="footer-popover"
            title={!this.props.isClickable ? 'Begin Form?' : 'Edit Form?'}>
            <div className="list-footer-quarterly" >
 
                <DropdownButton
                    id="dropdown"
                    title={this.state.year}
                    className="bootstrap-dropdown"
                    onChange={e => this.handleQuarterChange(e.target.value, this.state.quarter)}
                >
                    {years().map((year, index) => {
                        return <MenuItem
 
                            key={index}
                            eventKey="4"
                            onClick={e => this.handleQuarterChange(year.value, this.state.quarter)}
                        >
                            {year.label}
                        </MenuItem>;
                    })}
                </DropdownButton>
 
                <DropdownButton
                    id="dropdown"
                    title={this.state.quarterString}
                    className="bootstrap-dropdown"
                    onChange={e => this.handleQuarterChange(this.state.year, e.target.value)}
                >
                    {quarterMonths().map((year, index) => {
                        return <MenuItem
                            key={index}
                            eventKey="4"
                            onClick={e => this.handleQuarterChange(this.state.year, year.value)}
                        >
                            {year.label}
                        </MenuItem>;
                    })}
                </DropdownButton>
            </div>
            <div className="popover-footer-button" >
                {( +this.state.year<2024 || +this.state.quarter< 3 ? <button
                    onClick={() => this.getURLOfShopInspectionForm(redirectTo)}
                >{!this.props.isClickable ? 'Begin Form' : 'Edit Form'}</button> : <p>You can Add/Update inspections upto 2nd Qtr, 2024. Please <a target="_blank" href='https://www.enviroconnect.net/'>click here</a> for new EnviroConnect portal.</p> )}
            </div>
        </Popover>;
        return popOverTop;
    }
 
    renderQTRVisualPopOver = (plantUID: string, formType: string, outFall: string) => {
        const { redirectTo } = this.props;
        const popOverTop = <Popover
            id="popover-positioned-top"
            className="footer-popover"
            title={!this.state.isClickable ? 'Begin Form?' : 'Edit Form?'}>
            <div className="list-footer-quarterly" >
 
                <DropdownButton
                    id="dropdown"
                    title={this.state.year}
                    className="bootstrap-dropdown"
                    onChange={e => this.handleQuarterChange(e.target.value, this.state.quarter)}
                >
                    {years().map((year, index) => {
                        return <MenuItem
 
                            key={index}
                            eventKey="4"
                            onClick={e => this.handleQuarterChange(year.value, this.state.quarter)}
                        >
                            {year.label}
                        </MenuItem>;
                    })}
                </DropdownButton>
 
                <DropdownButton
                    id="dropdown"
                    title={this.state.quarterString}
                    className="bootstrap-dropdown"
                    onChange={e => this.handleQuarterChange(this.state.year, e.target.value)}
                >
                    {quarterMonths().map((year, index) => {
                        return <MenuItem
                            key={index}
                            eventKey="4"
                            onClick={e => this.handleQuarterChange(this.state.year, year.value)}
                        >
                            {year.label}
                        </MenuItem>;
                    })}
                </DropdownButton>
 
                <DropdownButton
                    id="dropdown"
                    title={this.state.selectedOutfall || 'Outfall'}
                    className="bootstrap-dropdown"
                    onChange={e => this.handleOutfallSelect(e.target.value)}
                >
                    {this.getOutFalls().map((outFall, index) => {
                        return <MenuItem
                            className={outFall.className}
                            key={index}
                            eventKey="4"
                            onClick={e => this.handleOutfallSelect(outFall.value)}
                        >
                            {outFall.key}
                            &nbsp;
                            {outFall.className && <i className="fa fa-check" aria-hidden="true"></i>}
                        </MenuItem>;
                    })}
                </DropdownButton>
            </div>
            <div className="popover-footer-button" >
                {/* <button
                    onClick={() => this.getURLOfQTRVisualForm(redirectTo)}
                >{!this.state.isClickable ? 'Begin Form' : 'Edit Form'}</button> */}
 
                {( +this.state.year<2024 || +this.state.quarter< 3 ? <button
                    onClick={() => this.getURLOfQTRVisualForm(redirectTo)}
                >{!this.props.isClickable ? 'Begin Form' : 'Edit Form'}</button> : <p>You can Add/Update inspections upto 2nd Qtr, 2024. Please <a target="_blank" href='https://www.enviroconnect.net/'>click here</a> for new EnviroConnect portal.</p> )}
            </div>
        </Popover>;
        return popOverTop;
    }
    renderShopInspectionPopOverOld = (plantUID: string, formType: string, outFall: string) => {
        const { redirectTo, isClickable } = this.props;
        let quarter;
        const popOverTop = <Popover
            id="popover-positioned-top"
            className="footer-popover"
            title={!this.props.isClickable ? 'Begin Form?' : 'Edit Form?'}>
            <div className="list-footer-quarterly" >

                <DropdownButton
                    id="dropdown"
                    title={this.state.year}
                    className="bootstrap-dropdown"
                    onChange={e => this.handleQuarterChange(e.target.value, this.state.quarter)}
                >
                    {years().map((year, index) => {
                        return <MenuItem

                            key={index}
                            eventKey="4"
                            onClick={e => this.handleQuarterChange(year.value, this.state.quarter)}
                        >
                            {year.label}
                        </MenuItem>;
                    })}
                </DropdownButton>

                <DropdownButton
                    id="dropdown"
                    title={this.state.quarterString}
                    className="bootstrap-dropdown"
                    onChange={e => this.handleQuarterChange(this.state.year, e.target.value)}
                >
                    {quarterMonths().map((year, index) => {
                        return <MenuItem
                            key={index}
                            eventKey="4"
                            onClick={e => this.handleQuarterChange(this.state.year, year.value)}
                        >
                            {year.label}
                        </MenuItem>;
                    })}
                </DropdownButton>
            </div>
            <div className="popover-footer-button" >
                <button
                    onClick={() => this.getURLOfShopInspectionForm(redirectTo)}
                >{!this.props.isClickable ? 'Begin Form' : 'Edit Form'}</button>
            </div>
        </Popover>;
        return popOverTop;
    }

    renderQTRVisualPopOverOld = (plantUID: string, formType: string, outFall: string) => {
        const { redirectTo } = this.props;
        const popOverTop = <Popover
            id="popover-positioned-top"
            className="footer-popover"
            title={!this.state.isClickable ? 'Begin Form?' : 'Edit Form?'}>
            <div className="list-footer-quarterly" >

                <DropdownButton
                    id="dropdown"
                    title={this.state.year}
                    className="bootstrap-dropdown"
                    onChange={e => this.handleQuarterChange(e.target.value, this.state.quarter)}
                >
                    {years().map((year, index) => {
                        return <MenuItem

                            key={index}
                            eventKey="4"
                            onClick={e => this.handleQuarterChange(year.value, this.state.quarter)}
                        >
                            {year.label}
                        </MenuItem>;
                    })}
                </DropdownButton>

                <DropdownButton
                    id="dropdown"
                    title={this.state.quarterString}
                    className="bootstrap-dropdown"
                    onChange={e => this.handleQuarterChange(this.state.year, e.target.value)}
                >
                    {quarterMonths().map((year, index) => {
                        return <MenuItem
                            key={index}
                            eventKey="4"
                            onClick={e => this.handleQuarterChange(this.state.year, year.value)}
                        >
                            {year.label}
                        </MenuItem>;
                    })}
                </DropdownButton>

                <DropdownButton
                    id="dropdown"
                    title={this.state.selectedOutfall || 'Outfall'}
                    className="bootstrap-dropdown"
                    onChange={e => this.handleOutfallSelect(e.target.value)}
                >
                    {this.getOutFalls().map((outFall, index) => {
                        return <MenuItem
                            className={outFall.className}
                            key={index}
                            eventKey="4"
                            onClick={e => this.handleOutfallSelect(outFall.value)}
                        >
                            {outFall.key}
                            &nbsp;
                            {outFall.className && <i className="fa fa-check" aria-hidden="true"></i>}
                        </MenuItem>;
                    })}
                </DropdownButton>
            </div>
            <div className="popover-footer-button" >
                <button
                    onClick={() => this.getURLOfQTRVisualForm(redirectTo)}
                >{!this.state.isClickable ? 'Begin Form' : 'Edit Form'}</button>
            </div>
        </Popover>;
        return popOverTop;
    }

    renderCompletedOutfall = () => {
        const options:any = [];
        const settledFormInstance = SettledFormModel.get(this.props.id);
        const formInstance = PlantModel.get(this.props.id);
        settledFormInstance.props.InCompleteOutfalls.forEach((outfall, index) => {
            options.push(<option className="completed" key={index} >{outfall}</option>);
        });
        return options;
    }

    getOutFalls = () => {
        const plantInstance = PlantModel.get(this.props.plantUID);
        const settledFormInstance = SettledFormModel.get(this.props.plantUID);
        if (settledFormInstance && plantInstance) {
            const { props: { InCompleteOutfalls, Outfalls } } = settledFormInstance;
            const outFalls:any = [];
            let i = 1;
            for (const key in Outfalls) {
                outFalls.push({
                    key: key,
                    value: key,
                    className: (InCompleteOutfalls.indexOf(key) > -1 ? '' : 'completed')
                });
                i++;
            }
            return outFalls;
        }
        return [];
    }

    renderPopOverById = (id: string) => {
        let { onClick, InCompleteOutfalls, label, isClickable, outfall, plantUID } = this.props;
        outfall = outfall || '';
        const monthly = id.substring(0, 7);
        switch (id) {
            case 'DailyForm':
                return this.renderPopOverTop(plantUID, id, outfall);
            case 'Monthly':
                return this.renderMonthlyPopOver(plantUID, id, outfall);
            case 'QTRVisual':
                return this.renderQTRVisualPopOver(plantUID, id, outfall);
            case 'ShopInspection':
                return this.renderShopInspectionPopOver(plantUID, id, outfall);
            default:
                return <span />;
        }
    }

    render() {
        const { onClick, InCompleteOutfalls, label, isClickable, id, plantUID } = this.props;
        const isCompleted = isClickable.toString().length > 0 && typeof isClickable === 'string';
        const isPending = isClickable.toString().length <= 0;
        const isNotAllowed = typeof isClickable === 'boolean';
        return <div >
            <div
                className={`card-active card ${isNotAllowed ? 'not-allowed' : ''}`}
                style={isNotAllowed ? { backgroundColor: '#4c4c4c' } : {}}
            >
                {isNotAllowed ?
                    <span style={{
                        display: 'flex',
                        justifyContent: 'center'
                    }} >
                        {!isNotAllowed ? <i className="fa fa-check-circle" aria-hidden="true"></i> : ''}
                        {<span>{label}</span>}
                    </span>
                    :
                    <OverlayTrigger
                        rootClose
                        trigger="click"
                        placement="top"
                        overlay={this.renderPopOverById(id)}
                    >
                        <span style={{
                            display: 'flex',
                            justifyContent: 'center'
                        }} >
                            {isCompleted ? <i className="fa fa-check-circle" aria-hidden="true"></i> : ''}
                            {<span>{label}</span>}
                        </span>
                    </OverlayTrigger>}
            </div>
        </div >;
    }
}
export function mapStateToProps(state) {
    return {
        state
    };
}

// export const FooterCard = withRouter(connect<{}, {}, FooterCardImpl>(mapStateToProps)(FooterCardImpl) as any);
// export const FooterCard = withRouter(connect<IFooterCardProps, any, any>(mapStateToProps)(FooterCardImpl as any))

export const FooterCard = withRouter(FooterCardImpl);




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Inspections/FooterCard.tsx